/**
 * Created by tomers on 5/31/2015.
 */

define(function (require) {
    "use strict";

    var LE = require("app");

    var template = require("user-management-templates/users/userListLayout.tmpl");
    var Paging = require("ui/paging/Paging");
    var DropdownMenu = require("ui/dropdown-menu/DropdownMenu");
    var InputSearch = require("ui/input-search/InputSearch");

    var ACTION_MENU_ITEMS = {
        ADD: "add",
        EDIT: "edit",
        DUPLICATE: "duplicate",
        SKILLS: "assignSkills",
        DELETE: "delete",
        CONCURRENCY: "setConcurrency",
        EXPORT: "exportAll"
    };

    var UserListLayout = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

        UserListLayout = Marionette.Layout.extend({
            className: "user-list",
            template: template,
            isPermanent: true,
            ui: {
                actionMenuContainer: ".action-menu",
                pagingContainer: ".user-list-paging-container",
                searchContainer: ".search-container"
            },
            regions: {
                gridRegion: ".users-grid-container",
                dialogContainerRegion: ".dialog-container"
            },
            uiComponents: {
                paging: {
                    type: Paging,
                    options: {
                        el: "view.ui.pagingContainer",
                        collection: "view.usersCollection",
                        blockWrongPageNumber: true
                    },
                    events: {
                        "change:page": "_onPagingChange"
                    }
                },
                actionMenu: {
                    type: DropdownMenu,
                    options: {
                        el: "view.ui.actionMenuContainer",
                        name: LE.translator.translate("LEFramework.global.captions.action"),
                        collection: "view._getActionMenuCollection"
                    },
                    events: {
                        "change": "_onActionMenuSelected"
                    }
                },
               search: {
                    type: InputSearch,
                    options: {
                        el: "view.ui.searchContainer",
                        permutation: InputSearch.Permutation.A
                        //placeholder: LE.translator.translate("LEUserManagement.userEdit.loginName.placeholder.new")
                    },
                    events: {
                        enterPressed: "_onSearchString",
                        onClickIcon: "_onSearchString",
                        onKeyUp: "_saveSearchTerm",
                        onblur: "_onSearchString"
                    }
                }
            },
            initialize: function(options) {
                this._initialize(options);
            },
            onClose: function () {
                LEUserManagement.logger.debug("closing users list layout view", "UserListLayout::onClose");
            },

            _initialize: function(options) {
                LEUserManagement.logger.debug("_initialize users list layout view", "UserListLayout::_initialize");
                options = options || {};
                if (options.displayAcUsersExport) {
                    this.displayExportUsersOption = options.displayAcUsersExport;
                }
                if (options.displayAcUsersDuplicate) {
                    this.displayAcUsersDuplicate = options.displayAcUsersDuplicate;
                }
                if (options.displayAcUsersAdd) {
                    this.displayAcUsersAdd = options.displayAcUsersAdd;
                }
                if (options.displayAssignSkills) {
                    this.displayAssignSkills = options.displayAssignSkills;
                }
                if (options.displaySetConcurrency) {
                    this.displaySetConcurrency = options.displaySetConcurrency;
                }
                this.usersCollection = options.usersCollection;
                this.showClearSelection = !!options.showClearSelection;
                this.channel = LEUserManagement.media.channel(LEUserManagement.channels.USER_LIST);
                this._bindEvents();
                this.searchStringValue = options.searchStringValue;
                this._prepareUiComponents();
            },

            onRender: function() {
                LEUserManagement.logger.debug("onRender", "UserListLayout::onRender");
                this.uiComponents.search.setValue(this.searchStringValue);
                this.uiComponents.search.handleChange();
                if (this.showClearSelection) {
                    this.listenTo(this.uiComponents.paging, "clearSelection", this._clearSelection);
                }
            },

            _bindEvents: function() {
                LEUserManagement.logger.debug("_bindEvents", "UserListLayout::_bindEvents");
                this.listenTo(this.usersCollection ,"reset", this._onCollectionReset);
                this.listenTo(this.channel, "actionMenu:set", this._onActionMenuSet);
            },

            _prepareUiComponents: function() {
                LEUserManagement.logger.debug("_prepareUiComponents", "UserListLayout::_prepareUiComponents");
                this.uiComponents.paging.options.showClearSelection = this.showClearSelection;
            },

            _onCollectionReset: function(collection, options) {
                LEUserManagement.logger.debug("_onCollectionReset", "UserListLayout::_onCollectionReset");
                // set correct paging
                var pagingInfo = this.usersCollection.getPagerInfo();
                this.uiComponents.paging.setInfo(pagingInfo.currentPageNumber, pagingInfo.totalPages);
            },
            _getActionMenuCollection: function() {
                LEUserManagement.logger.debug("_getActionMenuCollection", "UserListLayout::_getActionMenuCollection");
                var itemsArr = [];
                _.each(ACTION_MENU_ITEMS, function(item) {
                    if (item === ACTION_MENU_ITEMS.ADD) {
                        if(this.displayAcUsersAdd) {
                            itemsArr.push(this._createActionItem(item));
                        }
                    } else if (item === ACTION_MENU_ITEMS.DUPLICATE) {
                        if(this.displayAcUsersDuplicate) {
                            itemsArr.push(this._createActionItem(item));
                        }
                    } else if (item === ACTION_MENU_ITEMS.EXPORT) {
                        if(this.displayExportUsersOption) {
                            itemsArr.push(this._createActionItem(item));
                        }
                    } else if (item === ACTION_MENU_ITEMS.SKILLS) {
                        if(this.displayAssignSkills) {
                            itemsArr.push(this._createActionItem(item));
                        }
                    } else if (item === ACTION_MENU_ITEMS.CONCURRENCY) {
                        if(this.displaySetConcurrency) {
                            itemsArr.push(this._createActionItem(item));
                        }
                    } else {
                        itemsArr.push(this._createActionItem(item));
                    }
                }, this);
                this.actionsCollection = new DropdownMenu.Collection(itemsArr);
                return this.actionsCollection;
            },
            _createActionItem: function(itemId) {
                return {
                    id: itemId,
                    actionName: LE.translator.translate("LEFramework.global.captions." + itemId),
                    align: "right",
                    title: LE.translator.translate("LEFramework.global.captions." + itemId + ".tooltip")
                };
            },

            _onActionMenuSet: function(options) {
                var actionItemModel = this.actionsCollection.get(options.id);
                if (!_.isEmpty(actionItemModel)) {
                    actionItemModel.set("enabled", options.enabled);
                    if (typeof options.title !== "undefined") {
                        actionItemModel.set("title", options.title);
                    }
                }
            },

            _onActionMenuSelected: function(componentId, eventName, selectedItemId) {
                this.channel.trigger("actionMenu:select", selectedItemId);
            },

            _clearSelection: function () {
                this.channel.trigger("paging:clear");
            },

            _onPagingChange: function(componentId, eventName, currentPageNumber) {
                this.channel.trigger("paging:change", currentPageNumber);
            },

            _onSearchString: function(componentId, eventName, searchValue) {
                this.channel.trigger("search:initiate", searchValue);
            },

            _saveSearchTerm: function(componentId, eventName, searchValue) {
               this.channel.trigger("search:updateValue", searchValue);
            }
        });

    }

    LE.module("LEUserManagement", moduleDefinition);

    UserListLayout.ACTION_MENU_ITEMS = ACTION_MENU_ITEMS;

    return UserListLayout;
});
